import React from "react";
import classNames from "classnames";
import { IconProps } from "./PropsType";

export default function Icon(props: IconProps) {
  const {
    children,
    spin,
    icon = "",
    size,
    rotate,
    className,
    prefixCls = "bm-Icon",
    ...other
  } = props;
  const styleClass = classNames(
    prefixCls,
    "material-icons",
    size ? `${prefixCls}-${size}` : "",
    rotate ? `${prefixCls}-${rotate}` : "",
    spin ? `${prefixCls}-spin` : "",
    className
  );
  const handleClick = (event: any) => {
    if (props.onClick) {
      props.onClick(event);
    }
  };
  return (
    <i className={styleClass} {...other} onClick={handleClick}>
      {icon}
    </i>
  );
}
